<template>
    <div class="booking-slide">
        <h3 class="w-full font-sans font-medium text-center text-blue-500 h2">
            {{ ui.location.heading }}
        </h3>
        <p v-if="ui.location.text" class="mt-6 font-normal text-center text-blue-500">
            {{ ui.location.text }}
        </p>
        <p class="mt-6 font-normal text-center text-blue-500">
            Showing locations for {{ serviceDisplayTitle.toLowerCase() }}
        </p>

        <div role="radiogroup" aria-labelledby="location" class="mt-6">
            <BaseLabel
                id="location"
                class="pt-4"
                :text="'Preferred Location'"
                :validation="$v.location"
                :error-outline="false"
            >
                <div class="flex flex-col -my-1">
                    <BaseRadio
                        v-for="(option, index) in locations"
                        :key="index"
                        class="w-full my-1"
                        :disabled="isLoading"
                        :active="locationId && option.locationId == locationId"
                        :value="option.locationId"
                        :text="option.locationName"
                        @input="locationId = $event"
                    />
                </div>
            </BaseLabel>
        </div>

        <div role="radiogroup" aria-labelledby="newPatient" class="">
            <BaseLabel
                id="newPatient"
                class="pt-4"
                :text="'Are you a new Health Partners ' + serviceType + ' patient?'"
                :error-outline="false"
            >
                <div class="flex">
                    <BaseRadio
                        v-for="(option, index) in [true, false]"
                        :key="index"
                        :disabled="isLoading"
                        class="flex-grow mx-2 first:ml-0 last:mr-0"
                        :active="option == newPatient"
                        :value="option"
                        :text="option ? 'Yes' : 'No'"
                        @input="newPatient = $event"
                    />
                </div>
            </BaseLabel>
        </div>

        <!-- <button
            class="w-full mt-10 btn exception"
            :disabled="$v.$invalid"
            :class="{
                'btn--ghost-grey opacity-75': $v.$invalid && !isLoading,
                'btn--loading text-transparent': isLoading
            }"
            @click="submit"
        >
            Continue
        </button> -->
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import BaseLabel from '@/../vue/_base/form/Label.vue';
import BaseRadio from '@/../vue/_base/form/Radio.vue';
import ServiceTypeUtils from '@/../vue/online-booking/mixins/service-type-utils';

export default {
    components: {
        BaseLabel,
        BaseRadio
    },

    mixins: [ServiceTypeUtils],

    props: {
        serviceType: {
            type: String,
            required: true
        },
        ui: {
            type: Object,
            required: true
        },
        locations: {
            type: Array,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        }
    },

    data: () => ({
        locationId: undefined,
        newPatient: undefined
    }),

    validations: {
        locationId: {
            required
        },
        newPatient: {
            required
        }
    },

    watch: {
        $v: {
            handler() {
                if (!this.$v.$invalid) {
                    this.submit();
                }
            },
            deep: true
        }
    },

    methods: {
        submit() {
            if (!this.isLoading) {
                this.$emit('submit-data', {
                    locationId: this.locationId,
                    newPatient: this.newPatient
                });
                this.$emit('complete');
            }
        }
    }
};
</script>
